import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { searchParamSet, searchViewSet, } from '../../../../actions/SearchSolutionActions';
import { noneStyle } from '../../../../helpers/common';
import { propArrayShape, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import SearchCheckBox from './SearchCheckBox';
const extractMiddles = (large, middles) => middles.filter(({ solutionLargeClassId }) => solutionLargeClassId === large.id);
const getFirstView = (views) => Object.keys(views)
    .map((index) => ({
    index: index.indexOf('large_') === 0
        ? parseInt(index.replace('large_', ''), 10)
        : -1,
    result: views[index],
}))
    .find((row) => row.index >= 1 && row.result === true);
const getShowTarget = (showOpenValue, solutionLargeClass) => {
    if (showOpenValue) {
        return solutionLargeClass.find((large) => large.id === showOpenValue.index);
    }
    return null;
};
const SideMenuCategories = (props) => {
    const { removeParams, setView, solutionLargeClass, solutionMiddleClass, views, } = props;
    const showOpenValue = getFirstView(views);
    const showTarget = getShowTarget(showOpenValue, solutionLargeClass);
    const extracts = showTarget
        ? extractMiddles(showTarget, solutionMiddleClass)
        : [];
    return (_jsxs("div", Object.assign({ className: 'side-menu' }, { children: [_jsx("h2", { children: "\u30C6\u30FC\u30DE" }), _jsxs("div", Object.assign({ className: 'side-menu-main' }, { children: [_jsx("ul", Object.assign({ className: 'select-theme', style: showTarget ? noneStyle : null }, { children: solutionLargeClass.map((large) => (_jsx("li", Object.assign({ onClick: () => setView({ [`large_${large.id}`]: true }), role: 'presentation' }, { children: large.name }), large.id))) })), showTarget && (_jsx("aside", { children: _jsxs("div", Object.assign({ className: 'select-theme-box is-active' }, { children: [_jsxs("div", Object.assign({ className: 'themeClear', onClick: () => {
                                        setView({ [`large_${showTarget.id}`]: false });
                                        removeParams(extracts.map(({ id }) => id));
                                    }, role: 'presentation' }, { children: [showTarget.name, _jsx("i", Object.assign({ className: 'material-icons md-16' }, { children: "clear" }))] })), _jsx("ul", { children: extracts.map((middle) => (_jsx("li", { children: _jsx(SearchCheckBox, { id: `middle_${middle.id}`, label: middle.name, rowClassName: 'select-checkbox' }) }, middle.id))) })] })) }))] }))] })));
};
SideMenuCategories.propTypes = {
    removeParams: propFunc().isRequired,
    setView: propFunc().isRequired,
    solutionLargeClass: propArrayShape().isRequired,
    solutionMiddleClass: propArrayShape().isRequired,
    views: propShape().isRequired,
};
const mapStateToProps = ({ category, searchSolution }) => ({
    solutionLargeClass: category.solutionLargeClass,
    solutionMiddleClass: category.solutionMiddleClass,
    views: searchSolution.views || {},
});
const mapDispatchToProps = (dispatch) => ({
    removeParams: (ids) => {
        ids.forEach((setId) => {
            dispatch(searchParamSet({
                [`middle_${setId}`]: false,
            }));
        });
    },
    setView: (payload) => {
        dispatch(searchViewSet(payload));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(SideMenuCategories);
